<span>{{ getFormattedDateTime() }}</span>
